import { createContext } from "react";


class EventsStore {
  columnVisibility = {}
  columnFilters = []
  globalFilter = undefined
  searchField = 'title'
  pagination = { pageIndex: 0, pageSize: 10 }
  columnPinning = { left: [] }
  // State preservation fields
  allTableData = []
  tableData = []
  allEventCategories = []
  selectedChip = undefined
  isLoading = true
  isRefetching = false
  open = false
  scrollTop = 0
  needsRefresh = false
}


export const eventsStore = new EventsStore()
export const EventsStoreContext = createContext(eventsStore)
